var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"student-messages-page"},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{attrs:{"md":"5"}},[_c('v-card',{staticClass:"my-2",attrs:{"elevation":_vm.$vuetify.breakpoint.mdAndDown ? 0 : 2}},[_c('intract-smart-list',{attrs:{"paginated":"","handle-click":_vm.handleClick,"endpoint":_vm.studentEndpoint,"item-options":{
            title: 'full_name',
            subtitle: 'username',
            avatar: 'image',
            handleClick: _vm.handleClick,
          }},on:{"updateGetItemsFunction":function (f) { return (_vm.getItemsFunction = f); }}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }